import Typography from '@/components/typography';
import { ExportMenuButton } from '@/features/selectionsPanel/exportMenu/exportMenuLink';
import { useFooterButtonFunctions } from '@/features/selectionsPanel/hooks/useFooterButtonFunctions';
import { useSelectionsPanelContext } from '@/features/selectionsPanel/selectionsPanelProvider';

export const SelectionEmbedOptions = () => {
  const { setIsEmbedPanelOpen, totalSelectionCount } =
    useSelectionsPanelContext();
  const {
    shareButtonOptions: { disabled },
  } = useFooterButtonFunctions();

  return (
    <div className="pt-4">
      <Typography className="pb-1 pl-4" variant="button2">
        Website Embeds
      </Typography>
      <ExportMenuButton
        disabled={disabled}
        label="Embed Code"
        tooltip={!totalSelectionCount ? 'Make a Selection' : ''}
        onClick={() => setIsEmbedPanelOpen(true)}
      />
    </div>
  );
};
